import React from "react";

import { ErrorDetail } from "../../../components/ErrorDetail/ErrorDetail";

export const Error403: React.FC = () => {
  return (
    <>
      <ErrorDetail variant="error403" />
    </>
  );
};
